import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  ButtonGroup,
  Flex,
  Spinner,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  SimpleGrid,
  Card,
  CardHeader,
  CardBody,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  Icon,
  HStack,
  Tag,
  Tooltip,
  Link,
  useColorModeValue
} from '@chakra-ui/react';
import {
  FiSearch,
  FiFilter,
  FiDownload,
  FiArrowUp,
  FiArrowDown,
  FiDollarSign,
  FiActivity,
  FiCheckCircle,
  FiXCircle,
  FiClock,
  FiExternalLink,
  FiBarChart2,
  FiUsers,
  FiTrendingUp
} from 'react-icons/fi';
import { toast } from 'react-hot-toast';

// Mock data for operations
const mockOperations = [
  {
    id: 'tx1',
    token: 'BONK',
    type: 'buy',
    amount: '10,000,000',
    price: '$0.00002',
    value: '$200',
    timestamp: '2023-09-15 14:23',
    status: 'success',
    txHash: '4rzp2GKe5pFD9vkL8UF7DDTnQJX6FCrUNcysM4vzQb8R',
    proposer: 'AeHQ9zGXm9hYQBJGKP6FyrqzCKJ2HJiYYJ33EddEcSBf',
    executedBy: 'Treasury Multisig',
    chain: 'Solana',
    program: 'Jupiter',
    poolId: 'BONKLnAaZaKbFrV5G6AP1HnDCXDJsxS6Fk19hvfA5yP'
  },
  {
    id: 'tx2',
    token: 'SOL',
    type: 'sell',
    amount: '5',
    price: '$150',
    value: '$750',
    timestamp: '2023-09-14 10:45',
    status: 'success',
    txHash: '8Kpq7Hf3bQTwRKvr9aTb2RXm5pFvVhzAJBLXvjY5NcXh',
    proposer: '5r6XvjwbGze3RgWYRQQVxXrHgkPGXyNzmuVuLmWrPMjr',
    executedBy: 'Automated Strategy',
    chain: 'Solana',
    program: 'Orca',
    poolId: 'SOLmgYuBZQKtStLFqMcXGj7xJANRBKkWsPKfe1LFL2V'
  },
  {
    id: 'tx3',
    token: 'TRUMP',
    type: 'buy',
    amount: '3,000',
    price: '$0.05',
    value: '$150',
    timestamp: '2023-09-13 09:12',
    status: 'failed',
    txHash: '2jLm6Fg1XbWr5RvP9pLpJSdFe3tMwQ29Kkc5dRxTVPmZ',
    proposer: '8B1KUMqrM4ZYfDCWJQiyC5Zsfj7nWf7DXnNdLPf94eBr',
    executedBy: 'Treasury Multisig',
    chain: 'Solana',
    program: 'Raydium',
    poolId: 'TRUMPx5tVbqXKavt5X8iXn9zHLd1FyEchXBbZfcbKYt'
  },
  {
    id: 'tx4',
    token: 'WOOF',
    type: 'buy',
    amount: '5,000,000',
    price: '$0.0001',
    value: '$500',
    timestamp: '2023-09-12 17:34',
    status: 'success',
    txHash: '7pFd3Hs9LmX2tCt4XjD2yfKBTWPaV5jbQ4nRzEkVuS6W',
    proposer: '5D7KFj4MnRPLCViG6Dm8AJbKqFCmmYeRwNtLPR9GXBHe',
    executedBy: 'Flash Trade',
    chain: 'Solana',
    program: 'Meteora',
    poolId: 'WOOFjSPn9FmoLtGnGVTjdPP8hjZLJwFJaZPpTSKDL5Y'
  },
  {
    id: 'tx5',
    token: 'BERN',
    type: 'sell',
    amount: '1,500',
    price: '$0.20',
    value: '$300',
    timestamp: '2023-09-11 11:05',
    status: 'success',
    txHash: '5Tgn7Kp2LmJr6JmL8fWvYdKQeZLpFX9sQoH3MkRbV4Nx',
    proposer: '2F9gDwZ8RuMYbRXVbxLNW7FKpPWb4jzvbqZLQtE4y4N6',
    executedBy: 'Treasury Multisig',
    chain: 'Solana',
    program: 'Jupiter',
    poolId: 'BERNuYhB2jiYUFYR9d3JhAYxZoKK8PF8TyXLcjX6mNMH'
  },
  {
    id: 'tx6',
    token: 'DESOL',
    type: 'buy',
    amount: '50,000',
    price: '$0.004',
    value: '$200',
    timestamp: '2023-09-10 16:38',
    status: 'pending',
    txHash: 'DHfTvzES3LnvGpNZbLdNtQZYBYmkBqLKzpQhvQQF7qmW',
    proposer: '1L5HMeHvGbNS3XZpBcJQCQwYN4kmuPR7m7QA1sDU7aNV',
    executedBy: 'Pending',
    chain: 'Solana',
    program: 'Raydium',
    poolId: 'DESoLFRn3WsgeeSUwfMSCkSx38ujY5nF7Pnx5iBgBzmK'
  },
  {
    id: 'tx7',
    token: 'JTO',
    type: 'buy',
    amount: '25',
    price: '$3.60',
    value: '$90',
    timestamp: '2023-09-09 13:15',
    status: 'success',
    txHash: 'JT9HnV5cER2XmFLYwP3pZgXfLvS7JToBrkfYZNgLQrxD',
    proposer: '6Q8FTVxRq4zkV5FkHAND5dCbvr5SjQ9rBHPMmyT9zZC',
    executedBy: 'Automated Strategy',
    chain: 'Solana',
    program: 'Orca',
    poolId: 'JTOHSVdZQhkvJRgQyxMdJ2GGpHM2RKa8GtTVa5UcbUcF'
  }
];

const EnhancedExplorer = () => {
  const [operations, setOperations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate API call
    const fetchOperations = async () => {
      try {
        // In a real app, this would be an API call
        // await api.get('/explorer/operations')
        
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        setOperations(mockOperations);
      } catch (error) {
        console.error('Error fetching operations:', error);
        toast.error('Failed to fetch operation data');
        // Still set mock data in case of error
        setOperations(mockOperations);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOperations();
  }, []);

  // Helper function for status badge
  const getStatusBadge = (status) => {
    if (status === 'success') {
      return <Badge colorScheme="green">Success</Badge>;
    } else if (status === 'failed') {
      return <Badge colorScheme="red">Failed</Badge>;
    } else {
      return <Badge colorScheme="yellow">Pending</Badge>;
    }
  };

  // Helper function for action text
  const getActionText = (type) => {
    if (type === 'buy') {
      return <Text color="green.400">Buy</Text>;
    } else {
      return <Text color="red.400">Sell</Text>;
    }
  };

  return (
    <Container maxW="container.xl" py={8}>
      <Box mb={8}>
        <Heading as="h1" size="xl" mb={4}>
          Transaction Explorer
        </Heading>
        <Text fontSize="lg" color="gray.400" mb={6}>
          View recent transactions from the Desol AI Treasury
        </Text>
        
        {isLoading ? (
          <Flex justify="center" align="center" minHeight="300px">
            <Spinner size="xl" color="brand.400" thickness="4px" />
          </Flex>
        ) : (
          <Box overflowX="auto">
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Token</Th>
                  <Th>Action</Th>
                  <Th>Amount</Th>
                  <Th>Value</Th>
                  <Th>Time</Th>
                  <Th>Status</Th>
                  <Th>Transaction Hash</Th>
                </Tr>
              </Thead>
              <Tbody>
                {operations.map((op) => (
                  <Tr key={op.id}>
                    <Td fontWeight="bold">{op.token}</Td>
                    <Td>{getActionText(op.type)}</Td>
                    <Td>{op.amount}</Td>
                    <Td>{op.value}</Td>
                    <Td>{op.timestamp}</Td>
                    <Td>{getStatusBadge(op.status)}</Td>
                    <Td>
                      <Text fontFamily="mono" fontSize="sm">
                        {op.txHash}
                      </Text>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default EnhancedExplorer;